import * as React from 'react'

import { spacing, styled } from '@thg-commerce/enterprise-theme'
import { Image } from '@thg-commerce/gravity-elements'
import { AmpCarousel } from '@thg-commerce/gravity-amp'
import { useFormattableI18nProperty } from '@thg-commerce/enterprise-core'
import { v4 as uuid } from 'uuid'

import { GalleryThumbnail, GalleryItem } from './GalleryThumbnail'

export interface GalleryProps {
  items: GalleryItem[]
  isAmp: boolean
}

const GalleryWrapper = styled.div`
  display: flex;
  flex-direction: column;
`

const GalleryThumbnailWrapper = styled.div`
  display: flex;
  align-items: center;
  margin-top: ${spacing(2)};
`

const StyledImage = styled(Image)`
  max-height: 240px;
  background-color: transparent;
`

export const Gallery = (props: GalleryProps) => {
  const [activeIndex, setActiveIndex] = React.useState<number>(0)
  const galleryUuid = uuid()

  if (props.isAmp) {
    const AllGalleryImages = props.items.map((item, index) => (
      <Image
        src={[{ url: item.src }]}
        width={392}
        height={235}
        alt={item.alt || ''}
        isAmp={true}
        testId={`active-gallery-item-${index}`}
        key={index}
      />
    ))

    return (
      <GalleryWrapper>
        <AmpCarousel
          id={`gallery-${galleryUuid}`}
          width="450"
          height="300"
          layout="responsive"
          type="slides"
          role="region"
          aria-label={`gallery-${galleryUuid}`}
        >
          {AllGalleryImages}
        </AmpCarousel>
      </GalleryWrapper>
    )
  }

  const i18nViewImage = useFormattableI18nProperty(
    'general.gallery.viewimage.text',
  )
  const GalleryThumbnails = props.items.map((item, index) => (
    <GalleryThumbnail
      src={item.src}
      alt={item.alt}
      visuallyHiddenText={i18nViewImage((index + 1).toString())}
      active={index === activeIndex}
      onClick={() => setActiveIndex(index)}
      key={index}
      testId={`gallery-thumbnail-${index}`}
      isAmp={props.isAmp}
    />
  ))

  return (
    <GalleryWrapper>
      <StyledImage
        src={[{ url: props.items[activeIndex].src }]}
        width="100%"
        height="auto"
        alt={props.items[activeIndex].alt || ''}
        isAmp={false}
        testId="active-gallery-item"
        imageStyle="contain"
      />
      {GalleryThumbnails.length > 1 && (
        <GalleryThumbnailWrapper>{GalleryThumbnails}</GalleryThumbnailWrapper>
      )}
    </GalleryWrapper>
  )
}
